// extracted by mini-css-extract-plugin
export default {"header":"deviceDetection_header__gmPhN","redirectContainer":"deviceDetection_redirectContainer__5ZOuy"};